export default {
  adUnitPath: '/124312541,2820490/Pitchero/ros_mpu2',
  size: [
    [300, 600],
    [300, 250],
  ],
  id: 'ros-bottom-mpu',
  targeting: {
    Pitchero_Ad_Position: ['BTF'],
    Pitchero_Ad_Size: ['bottom_mpu'],
  },
};
